(function () {
  if (window.__codaeScrollRevealInit) return;
  window.__codaeScrollRevealInit = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function init() {
    var els = document.querySelectorAll('.reveal:not(.is-visible)');

    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  var parallaxItems = [];
  var parallaxTicking = false;

  function renderParallax() {
    parallaxTicking = false;
    var vh = window.innerHeight;

    parallaxItems.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;

      var strength = parseFloat(el.getAttribute('data-parallax')) || 10;
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + rect.height / 2);
      var shift = (progress * strength * -1).toFixed(2);

      el.style.transform = 'translate3d(0, ' + shift + '%, 0) scale(1.14)';
    });
  }

  function onParallaxScroll() {
    if (!parallaxTicking) {
      parallaxTicking = true;
      window.requestAnimationFrame(renderParallax);
    }
  }

  function initParallax() {
    if (prefersReduced) return;

    parallaxItems = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!parallaxItems.length) return;

    renderParallax();
  }

  function initAll() {
    init();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('scroll', onParallaxScroll, { passive: true });
  window.addEventListener('resize', onParallaxScroll);
  document.addEventListener('shopify:section:load', initAll);
})();
